var map = {
	"./00-fish-bike.webp": 105,
	"./01_whale.webp": 106,
	"./02_ice.webp": 107,
	"./03_bath.webp": 108,
	"./04_galago.webp": 109,
	"./05_cosmos.webp": 110,
	"./06_eye.webp": 111,
	"./08_meow.webp": 112,
	"./09_crocodile.webp": 113,
	"./10_papugi.webp": 114,
	"./11_whale2.webp": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;